import { MidwayTokenError } from "../errors/midwayError";

export const MIDWAY_DOMAIN = "midway-auth.amazon.com";

/*
 * Partly inspired from https://code.amazon.com/packages/MidwayIdentityCredentialProvider/blobs/d72613cf102b4c207dffe2cc3f3edad9ed1e5b97/--/src/token-retriever.ts#L51
 */

//QueryParameters = { [key: string]: string };

export function generateNonce() {
  let nonce = "";
  const characterSet =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 64; i += 1) {
    nonce += characterSet.charAt(
      Math.floor(Math.random() * characterSet.length),
    );
  }
  return nonce;
}

function buildQuery(props) {
  return Object.keys(props).reduce(
    (accumulator, key) => `${accumulator + key}=${props[key]}&`,
    "?",
  );
}

function buildSSOUrl() {
  const queryParams = {
    response_type: "id_token",
    client_id: encodeURIComponent(window.location.host),
    redirect_uri: encodeURIComponent(window.location.href),
    scope: "openid",
    nonce: generateNonce(),
  };

  return `https://${MIDWAY_DOMAIN}/SSO${buildQuery(queryParams)}`;
}

function buildRedirectUrl() {
  const queryParams = {
    client_id: encodeURIComponent(window.location.host),
    redirect_uri: encodeURIComponent(window.location.href),
    response_type: "id_token",
    scope: "openid",
    nonce: generateNonce(),
  };

  return `https://${MIDWAY_DOMAIN}/login?next=/SSO/redirect${encodeURIComponent(
    buildQuery(queryParams),
  )}`;
}

const getMidwayToken = () => {
  return fetch(buildSSOUrl(), { credentials: "include" }).then(
     response => {
      if (response.ok) {
        const token = response.text();
        return token;
      } else {
        window.location.href = buildRedirectUrl();
        throw new MidwayTokenError();
      }
    },
  );
};

export default getMidwayToken;


// WEBPACK FOOTER //
// ./src/utils/getMidwayToken.js